export default "__VITE_ASSET__DUWXMjS9__"